import { motion } from "framer-motion";
import { ArrowDown } from "lucide-react";

export const SectionLink = ({ to, title }) => (
  <motion.a
    href={to}
    data-testid="section-link"
    initial={{ opacity: 0 }}
    whileInView={{ opacity: 1 }}
    viewport={{ once: true }}
    transition={{ duration: 0.8 }}
    className="group relative mx-auto flex max-w-7xl items-center justify-between gap-6 border-y border-foreground/10 px-6 py-10 md:px-10 md:py-14"
  >
    <span className="relative hidden h-px flex-1 bg-foreground/10 md:block">
      <span className="absolute left-0 top-0 h-px w-0 bg-primary transition-[width] duration-700 ease-out group-hover:w-full" />
    </span>

    <span className="flex items-center gap-4">
      <span className="font-heading text-xl font-black tracking-tight text-foreground transition-colors duration-300 group-hover:text-primary sm:text-2xl md:text-4xl">
        {title}
      </span>
      <span className="flex h-11 w-11 items-center justify-center rounded-full border border-foreground/15 text-muted-foreground transition-colors duration-300 group-hover:border-primary group-hover:text-primary md:h-14 md:w-14">
        <ArrowDown className="h-5 w-5 animate-bounce md:h-6 md:w-6" />
      </span>
    </span>
  </motion.a>
);
